var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"v-spinner d-flex flex-column align-items-center"},[_c('div',{staticClass:"v-clip mr-3",style:(_vm.spinnerStyle)})])
}
var staticRenderFns = []

export { render, staticRenderFns }